import digitalData from 'digital-data';
import { CATEGORY_RECOMMENDATION, TRENDING, STASH } from '../constants';

export const trendingCategories = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('trending-categories.click', (output) => {
    const ddoEvent = {
      eventInfo: {
        eventName: CATEGORY_RECOMMENDATION
      },
      category: {
        primaryCategory: STASH
      },
      eventMode: STASH,
      stash: {
        recommendation: {
          categoryRecommendationType: TRENDING
        }
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};